import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";

import {
  DISCOUNT_SECTION_TYPES,
  discountInterface,
  discountSectionsInterface,
  DISCOUNT_FINANCE_CELLS
} from "./discounstInterface";
import {
  setAllFinanceOptionsPopupVisible,
  setDiscountSections, setFinanceCellsVisible,
  setFinancePercentage, setFinanceActiveDiscount
} from "../../actions/priceWorksheetActions";
import DiscountDropdown from "../ui/dropdowns/discountDropdown";
import DiscountCommon from "./discountCommon";
import {
  calculateCellValue, getDiscountCurrentValue,
  getDiscountSectionsForCurrentWizard,
  shouldUseMultipleWorkSheets, someDiscountIsCashAndSelected, someDiscountIsSubTotalAndSelected
} from "./discountFunctions";
import {getQuotePriceWithTaxes, getTotalPrice} from "../../misc/helpers";
import UiIcon from "../ui/icons/uiIcon";


class DiscountFinance extends DiscountCommon {

  componentDidMount() {
    const {financePercentage, discountSections} = this.props;
    const financeSection = discountSections.find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);
    const parsedOptions = this.getParsedOptions();

    if (!financePercentage && financeSection) {
      const withPercentage = financeSection.discounts.find(dis => parsedOptions.includes(dis.uuId) && dis.financePercentage)
        || financeSection.discounts.find(dis => dis.financePercentage); // at least something
      if (withPercentage) {
        this.props.setFinancePercentage(withPercentage.financePercentage);
      }
    }
  }

  getParsedOptions = () => {
    const {discount, activeQuoteIndex, hasMultipleWorkSheets} = this.props;
    const realFinanceOptions = getDiscountCurrentValue(discount, "financeOptions", activeQuoteIndex,
      hasMultipleWorkSheets);
    return typeof realFinanceOptions === "string" ? JSON.parse(realFinanceOptions) : [];
  }
  //
  // activeCompanyChangeClick = (dropdownItem, financeSection) => {
  //   this.props.setFinanceActiveCompany(dropdownItem.discount.financeCompany);
  //   let parsedOptions = this.getParsedOptions();
  //   parsedOptions.forEach((uuId, index) => {
  //     if (!parsedOptions[index]) {
  //       return
  //     }
  //     const selectedDiscount = financeSection.discounts.find(dis => dis.uuId === parsedOptions[index]);
  //     if (selectedDiscount && !selectedDiscount.financeCompany || (selectedDiscount.financeCompany !== dropdownItem.discount.financeCompany)) {
  //       parsedOptions[index] = null;
  //     }
  //   });
  //   this.setDiscountProperty("financeOptions", JSON.stringify(parsedOptions));
  //   if (this.props.financeActiveDiscount
  //     && this.props.financeActiveDiscount.financeCompany
  //     && dropdownItem.discount.financeCompany
  //     && (this.props.financeActiveDiscount.financeCompany !== dropdownItem.discount.financeCompany)) {
  //     this.props.setFinanceActiveDiscount(null);
  //   }
  // }

  getCurrentDiscountHtml = (dis, withCompany = false) => {
    return dis.financePercentage + "%" + " for "
      + dis.financeMonths + " " + this.props.intl.formatMessage({id: "shoppingCart.discounts.months"})
      + (withCompany && dis.financeCompany ? " for " + dis.financeCompany : "");
  }

  monthChangeClick = (selectedItem, propertyIndex) => {
    let parsedOptions = this.getParsedOptions();
    parsedOptions[propertyIndex] = selectedItem.discount.uuId;
    this.setDiscountProperty("financeOptions", JSON.stringify(parsedOptions));
  }

  // getDropdownOptions = (financeSection, property) => {
  //   return financeSection.discounts.reduce((total, dis) => {
  //     if (!total.some(dropdownItem => dropdownItem.discount[property] === dis[property])) {
  //       total.push({
  //         value: dis.uuId || (dis.id + "-" + dis.order),
  //         text: dis[property],
  //         discount: dis,
  //       })
  //     }
  //     return total
  //   }, []);
  // }

  getFinanceDiscountOptions = (financeSection) => {
    return financeSection.discounts
      .map(dis => {
        return {
          value: dis.uuId || (dis.id + "-" + dis.order),
          text: this.getCurrentDiscountHtml(dis, true),
          discount: dis,
        }
      });
  }

  setCellVisible = () => {
    if (!this.props.fabricatorData.isAmericanStandard && !this.props.financeCellsVisible) {
      this.props.setFinanceCellsVisible(true);
    }
  }

  render() {
    const {discountSections, setAllFinanceOptionsPopupVisible, intl, financeCellsVisible, activeQuoteIndex, hasMultipleWorkSheets, fabricatorSettings} = this.props;
    const financeSection = discountSections.find(sec => sec.type === DISCOUNT_SECTION_TYPES.finance);
    if (!financeSection) {
      return null;
    }

    let parsedOptions = this.getParsedOptions();

    // console.log("parsedOptions", parsedOptions)
    // console.log("financeSection", financeSection);

    // const dropdownCompaniesOptions = this.getDropdownOptions(financeSection, "financeCompany");
    const dropdownMonthItems = this.getFinanceDiscountOptions(financeSection);

    const totalPrice = hasMultipleWorkSheets ? getTotalPrice(activeQuoteIndex) : getTotalPrice();
    const grandTotal = getQuotePriceWithTaxes(totalPrice, discountSections);

    const cellsAreDisabled = this.props.fabricatorData.isAmericanStandard
      && (someDiscountIsCashAndSelected(this.props.customAddedDiscounts, this.props.discountSections)
        || !someDiscountIsSubTotalAndSelected(
        this.props.discountSections, this.props.activeQuoteIndex, this.props.hasMultipleWorkSheets
        ));

    return (
      <li className={"discount discount--finance"}>
        <div className="text-left margin-b-12">
          {/*<span className="bold block">*/}
          {/*  <FormattedMessage id="shoppingCart.discounts.financeTitle"/>*/}
          {/*</span>*/}
          {/*<span className="block margin-b-8 text-left">*/}
          {/*  <FormattedMessage id="shoppingCart.discounts.financeSubTitle"/>*/}
          {/*</span>*/}
          <div className="flex flex--center flex--between">
            <span className="bold block">
              <FormattedMessage id="shoppingCart.discounts.financeTitle"/>
            </span>
            {/*<div className="inline-block">*/}
            {/*  <DiscountDropdown dropdownItems={dropdownCompaniesOptions}*/}
            {/*                    dropdownTitle={intl.formatMessage({id: "shoppingCart.discounts.financeCompany"})}*/}
            {/*                    selectItemClick={(selectedItem => this.activeCompanyChangeClick(selectedItem, financeSection))}>*/}
            {/*    <div className="dr-select">{financeActiveCompany || intl.formatMessage({id: "radioButtonAllWalls1"})}</div>*/}
            {/*  </DiscountDropdown>*/}
            {/*</div>*/}
            <button className="ui-button flex flex--center discount-info-button"
                    onClick={() => setAllFinanceOptionsPopupVisible(true)}>i</button>
          </div>
        </div>
        <div className="flex">
          {Object.keys(DISCOUNT_FINANCE_CELLS).map((property, propertyIndex) => {
            const selectedDiscount = financeSection.discounts.find(dis => dis.uuId === parsedOptions[propertyIndex]);
            const isChecked = this.props.financeActiveDiscount && this.props.financeActiveDiscount.uuId === parsedOptions[propertyIndex];
            return (
              <div className={"discount-finance__cell flex flex--center flex--1 relative discount-finance__cell--no-hover"}
                   onClick={this.setCellVisible}
                   key={property}>
                <DiscountDropdown dropdownItems={financeCellsVisible ? dropdownMonthItems : []}
                                  dropdownTitle={intl.formatMessage({id: "shoppingCart.discounts.term"})}
                                  selectItemClick={(selectedItem) => this.monthChangeClick(selectedItem, propertyIndex)}>
                  <div className="discount-finance__cell-months text-left u-pl-1 u-pr-3">
                    {selectedDiscount ? this.getCurrentDiscountHtml(selectedDiscount) : intl.formatMessage({id: "shoppingCart.discounts.selectTerm"})}
                  </div>
                </DiscountDropdown>
                <div className={"discount-finance__cell-checkbox absolute ui-checkbox ui-checkbox--normal"
                  + (cellsAreDisabled || !selectedDiscount ? " ui-checkbox--disabled" : "")
                  + (isChecked ? " ui-checkbox--checked-svg" : "")}
                     onClick={() => cellsAreDisabled || !selectedDiscount ? null : this.props.setFinanceActiveDiscount(selectedDiscount)}>
                  <div className="ui-checkbox__svg">
                    <UiIcon icon="checkmark"/>
                  </div>
                </div>
                <div className="discount-finance__cell-amount" style={cellsAreDisabled ? {fontSize: "20px"} : null}>
                  {financeCellsVisible ? calculateCellValue(
                    {
                      discountSections,
                      financePercentage: selectedDiscount ? selectedDiscount.financePercentage : 0,
                      fabricatorSettings,
                    },
                    selectedDiscount ? selectedDiscount.financeMonths : 0,
                    grandTotal,
                    activeQuoteIndex,
                    hasMultipleWorkSheets,
                    cellsAreDisabled,
                  ) : null}
                </div>
              </div>
            )
          })}
        </div>
      </li>
    )
  }
}

DiscountFinance.propTypes = {
  discount: PropTypes.shape(discountInterface),
  discountSection: PropTypes.shape(discountSectionsInterface),
};

const mapStateToProps = (store) => {
  const {
    discountSections,
    customAddedDiscounts,
    financePercentage,
    financeCellsVisible,
    workSheetsCount,
    financeActiveDiscount
  } = store.priceWorksheetState;
  const {allWizardsValues} = store.wizardState;
  const {activeQuoteIndex, quotes} = store.quotesState;
  const {jobIsSaving} = store.serverState;
  const {showAllQuotesCartItemsList} = store.cartState;

  return {
    discountSections: getDiscountSectionsForCurrentWizard(discountSections,
      allWizardsValues, activeQuoteIndex),
    customAddedDiscounts,
    financePercentage,
    financeCellsVisible,
    // Total requirements
    cartItems: store.cartState.cartItems,
    instList: store.instState.instList,
    fabricatorTaxes: store.fabricatorState.fabricatorTaxes,
    // Total requirements end
    fabricatorData: store.fabricatorState,
    fabricatorSettings: store.fabricatorState.settings,
    allWizardsValues,
    activeQuoteIndex,
    workSheetsCount,
    quotes,
    hasMultipleWorkSheets: shouldUseMultipleWorkSheets(workSheetsCount),
    jobIsSaving,
    financeActiveDiscount,
    showAllQuotesCartItemsList,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setFinancePercentage,
  setAllFinanceOptionsPopupVisible,
  setFinanceCellsVisible,
  setFinanceActiveDiscount,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(DiscountFinance)
)
